export { GlobeAlt as default } from './GlobeAlt';
